module.exports = __webpack_public_path__ + "img/c58648b.png";